import { DataBean } from "../DataBean";

export class AssignedMaintenanceType extends DataBean {

  public async getAssignedMaintenanceTypeCatalogPorPropiedades(
    properties: any,
    maxRows: number
  ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getAssignedMaintenanceTypeCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteAssignedMaintenanceType(
    idassignedmaintenancetype: number
  ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "boolean_deleteAssignedMaintenanceType_Number",
      [idassignedmaintenancetype]
    );
  }

  public async updateAssignedMaintenanceType(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.AssignedMaintenanceType_updateAssignedMaintenanceType_com.orange.finance.processcontract.bean.AssignedMaintenanceType",
      [
        {
          DataBeanProperties: bean,
          DataBeanName:"com.orange.finance.processcontract.bean.AssignedMaintenanceType",
        },
      ]
    );
  }
}
